(function(konto) {
	konto.sc = {};
} (konto = window.konto));
